module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Link 1: TRTC ultra-low-latency streaming":"Link 1: TRTC ultra-low-latency streaming","Link 2: LEB":"Link 2: LEB","Link 3: LVB":"Link 3: LVB"},"zh":{"Link 1: TRTC ultra-low-latency streaming":"线路一：TRTC超低延时观看","Link 2: LEB":"线路二：快直播观看","Link 3: LVB":"线路三：标准直播观看"}}')
  delete Component.options._Ctor
}
